import { render, staticRenderFns } from "./paramsOper.vue?vue&type=template&id=9157c2ac&scoped=true"
import script from "./paramsOper.vue?vue&type=script&lang=js"
export * from "./paramsOper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9157c2ac",
  null
  
)

export default component.exports